import * as cx from 'classnames';
import {
    AUTOMATIC_COMMENT_VIOLATES_RULES,
    DELETE,
    FORUM_COMMENT_EDIT_MENU,
    FORUM_COMMENT_MOVE_UP,
    SEND_HEART_TO_username,
    SHOW_USERS_WHO_LIKED_THIS_POST,
} from 'mk/autogenerated/translations/CommentMenu.3c70c81e1bf3b88338cd0caa3ab34e61'
import { getInlinedImages, linebreaksbr, mentionize, replaceImageMarks, urlize } from 'mk/bazaar/common/filters';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { hearts_url } from 'mk/urls/functions';
import { BLOG_POST_COMMENT_MENU_MORE } from 'mk2/apps/blogs/helpers';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import PostMenuTrigger from 'mk2/apps/forum/components/PostMenuTrigger';
import { FORUM_COMMENT_MENU_MORE } from 'mk2/apps/forum/helpers';
import * as forumUrls from 'mk2/apps/forum/urls';
import MenuItem from 'mk2/components/menu/MenuItem';
import Menu from 'mk2/containers/Menu/Menu';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import { matchPath, RouteComponentProps, withRouter } from 'react-router';
import styles from './CommentMenu.mscss';

interface OwnProps {
    className?: string;
    comment: CommentEntity;
    inGroups: boolean;
    role: 'author' | 'moderator' | 'admin' | null;
    requestUser: UserEntity;

    hasReport: boolean;
    hasEdit: boolean;
    hasDelete: boolean;
    hasMoveUp: boolean;

    onToggleMenuMore(commentId: number);
    onReport(entityType: string, commentId: number);
    onDelete(commentId: number);
    onMoveUp?(commentId: number);
    onSendHeart?();
}

type RouteProps = RouteComponentProps<{}>;
type Props = OwnProps & RouteProps;

class CommentMenu extends React.Component<Props> {

    public render() {
        const {
            className, comment, inGroups, role, location,
            hasReport, hasEdit, hasDelete, hasMoveUp,
            requestUser, onSendHeart,
        } = this.props;

        const showReport = hasReport && !comment.deletedAt;
        const showEdit = hasEdit && !comment.deletedAt;
        const showDelete = hasDelete && !comment.deletedAt;
        const showMoveUp = hasMoveUp && !comment.deletedAt;

        const match = matchPath<{
            topicSlug?: string;
            postSlug?: string;
        }>(location.pathname, { path: forumUrls.forumPostDetail, exact: true });

        return (showReport || showEdit || showDelete || showMoveUp) ? (
            <Menu
                className={cx(styles.CommentMenu, className)}
                menuId={inGroups ? BLOG_POST_COMMENT_MENU_MORE(comment.id) : FORUM_COMMENT_MENU_MORE(comment.id)}
                trigger={<PostMenuTrigger onClick={this.handleOnToggleMenuMore} />}
                triggerShadow={false}
            >

                {showReport && (
                    <MenuItem
                        label={AUTOMATIC_COMMENT_VIOLATES_RULES}
                        icon="fa-exclamation-triangle"
                        onClick={this.handleOnReport}
                    />
                )}

                <MenuItem
                    label={interpolate(SEND_HEART_TO_username, { username: `${comment.authorUser.username}` })}
                    icon="fa-heart-o"
                    link={isAuthenticated(requestUser) ? url(hearts_url(), {}, {
                        to: comment.authorUser.username,
                        next: location.pathname,
                    }) : null}
                    onClick={isAuthenticated(requestUser) ? null : onSendHeart}
                    asAnchor={isAuthenticated(requestUser)}
                />

                {/* This should be available only in post detail, so topic slug and post slug are our test */}
                {isAuthenticated(requestUser) && match && match.params.topicSlug && match.params.postSlug && comment.likeable.likesCount > 0 && (
                    <MenuItem
                        label={SHOW_USERS_WHO_LIKED_THIS_POST}
                        icon="fa-thumbs-o-up"
                        link={url(forumUrls.forumPostCommentLikers, {
                            topicSlug: match.params.topicSlug,
                            postSlug: match.params.postSlug,
                            commentId: comment.id,
                        })}
                    />
                )}

                {showEdit && (
                    <MenuItem
                        className={styles[`CommentMenu__item--${role}`]}
                        label={FORUM_COMMENT_EDIT_MENU}
                        icon="fa-pencil"
                        link={url(forumUrls.forumCommentEdit, {commentId: comment.id})}
                    />
                )}

                {showDelete && (
                    <MenuItem
                        className={styles[`CommentMenu__item--${role}`]}
                        label={DELETE}
                        icon="fa-trash"
                        onClick={this.handleOnDelete}
                    />
                )}
                {showMoveUp && (
                    <MenuItem
                        className={styles[`Comment__dropdownMenu__item--${role}`]}
                        label={FORUM_COMMENT_MOVE_UP}
                        icon="fa-pencil"
                        onClick={this.handleOnMoveUp}
                    />
                )}
            </Menu>
        ) : null;
    }

    private handleOnToggleMenuMore = () => {
        const { comment, onToggleMenuMore } = this.props;
        onToggleMenuMore(comment.id);
    };

    private handleOnReport = () => {
        const { comment, inGroups, onReport } = this.props;
        if (inGroups) {
            onReport('photoblog-comment', comment.id);
        } else {
            onReport('forum-message', comment.id);
        }
    };

    private handleOnDelete = () => {
        const { comment, onDelete } = this.props;
        onDelete(comment.id);
    };

    private handleOnMoveUp = () => {
        const { comment, onMoveUp } = this.props;
        onMoveUp(comment.id);
    };
}

export default withRouter<Props & RouteProps>(CommentMenu);
